export default __webpack_public_path__ + "files/forest-48e025c24be682a0738f67b6c262e004.png";